<template>
  <div class="main-content">

    <div class="card">
      <div class="card-header">
        <h6>Новая заявка
          <button @click="createOpen = !createOpen" v-if="!createOpen" class="btn btn-sm btn-primary">Создать</button>
        </h6>
      </div>
      <div class="card-body" v-if="createOpen">
        <newOrderSmallForm
          :orderUpdated="orderUpdated"
          :rates="rates"
          :byAgentReSeller="true"
        />
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5>Заявки для обработки <strong v-if="confirmOrders.length">({{ confirmOrders.length }})</strong>
          <vue-ladda @click="search" button-class="btn btn-sm btn-success pull-right"
                     data-style="zoom-in"
                     :loading="searchLoading">Обновить
          </vue-ladda>
        </h5>
      </div>
      <div class="card-body">

        <div class="text-center m-t-20" v-if="searchLoading">
          <pulse-loader :loading="searchLoading" :color="loadingColor"/>
        </div>
        <div v-if="confirmOrders.length">

          <div>
            <ordersEditList
              ref="orderList"
              :rates="rates"
              :orders="confirmOrders"
              viewType="confirm"
              :updateOrderDetails="updateOrderDetails"
            />
          </div>

          <div>
            <div class="flex">
              <div class="form-group w-50 pr-3">
                <label for="">Дата планируемой доставки (в Москве)</label>
                <datetime
                  input-class="form-control"
                  type="date"
                  :minute-step="60"
                  format="dd.MM.yyyy (cccc)"
                  :auto="true"
                  :min-datetime="minDateSelect"
                  :max-datetime="maxDateSelect"
                  v-model="deliveryDate"></datetime>
              </div>
              <div class="form-group w-100">
                <label for="">Адрес доставки (в Москве)</label>
                <input type="text" v-model="address" class="form-control" placeholder="Адрес доставки">
              </div>
            </div>
            <div>
              <label>Дополнительные препараты (по необходимости)</label>
              <DrugSearchNew
                ref="searchExtraDrug"
                :onSelect="addExtraDrug"
              />
              <table v-if="extraDrugs.length" class="table mt-0 table-sm table-hover table-small-td">
                <tbody>
                <tr v-for="(d,i) in extraDrugs">
                  <td>{{ i + 1 }}</td>
                  <td>{{ d.title }}</td>
                  <td><input type="number" v-model="d.qty" placeholder="количество" class="form-control"></td>
                  <td>
                    <button type="button" @click="extraDrugs = extraDrugs.filter((dd) => dd.id !== d.id)"
                            class="btn btn-outline-danger btn-sm"><i class="icon-fa icon-fa-trash"/></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <vue-ladda @click="createOneOrder" button-class="btn btn-sm pull-right btn-success"
                       data-style="zoom-in"
                       :loading="loadingBtn">Отправить на сборку выбранные заявки
            </vue-ladda>
          </div>

          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="currentPage"
                      :page-count="paginator.last_page"
                      :page-range="3"
                      :margin-pages="2"
                      :click-handler="search"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>

        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5>Заявки на доставку ({{ collectedOrders.length }})</h5>
      </div>
      <div class="card-body" v-if="collectedOrders.length">
        <ordersEditList
          ref="moderatingOrders"
          :rates="rates"
          :orders="collectedOrders"
          viewType="collectedOrders"
          :supplyOrders="supplyOrders"
          :updateOrderDetails="updateOrderDetails"
        />
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5>Заявки на модерации ({{ moderatingOrders.length }})
          <template v-if="moderatingOrders.length">
            <button @click="moderateOpen = !moderateOpen" class="btn btn-primary pull-right">
              {{ moderateOpen ? 'Скрыть' : 'Показать' }}
            </button>
          </template>
        </h5>
      </div>
      <div class="card-body" v-if="moderateOpen && moderatingOrders.length">
        <ordersEditList
          ref="moderatingOrders"
          :rates="rates"
          :orders="moderatingOrders"
          viewType="moderating"
          :updateOrderDetails="updateOrderDetails"
        />
      </div>
    </div>

  </div>
</template>


<script>

import api from '@/api'
import dateRange from '@/components/orders/dateRange'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import Paginate from 'vuejs-paginate'
import ordersEditList from "../../../components/orders/ordersEditList";
import newOrderSmallForm from "../../../components/orders/newOrderSmallForm";
import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import {Settings} from 'luxon'

Settings.defaultLocale = 'ru'
import moment from 'moment'
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  components: {
    dateRange,
    VueLadda,
    Paginate,
    ordersEditList,
    newOrderSmallForm,
    DrugSearchNew,
    Datetime
  },
  data() {
    return {
      extraDrugs: [],
      address: null,
      deliveryDate: null,
      minDateSelect: moment().format(),
      maxDateSelect: moment().add(10, 'days').format(),
      loadingBtn: false,
      createOpen: false,
      moderateOpen: false,
      rates: null,
      totalOrders: 0,
      searchLoading: false,
      confirmOrders: [],
      moderatingOrders: [],
      collectedOrders: [],
      supplyOrders: {},
      loadingColor: '#007dcc',
      paginator: null,
      currentPage: 1,
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    addExtraDrug(d) {
      if (d) {
        if (!this.extraDrugs.find((dd) => dd.id === d.id)) {
          this.extraDrugs.push({id: d.id, title: d.title, qty: 1, pack_set: d.pack_set});
        }
      }
    },
    orderUpdated(order) {
      this.createOpen = false;
      if (order) {
        this.moderatingOrders.push(order);
      }
    },
    async createOneOrder() {
      const allSelected = this.$refs.orderList.selected;
      const selected = Object.keys(allSelected).filter(x => allSelected[x]);
      let err = false;
      if (!selected.length) {
        toastr['warning']('Заявки не выбраны');
        err = true;
      }
      if (!this.address) {
        toastr['warning']('Укажите адрес доставки');
        err = true;
      }
      if (!this.deliveryDate) {
        toastr['warning']('Укажите дату доставки');
        err = true;
      }

      if (!err) {
        this.loadingBtn = true;
        let {data} = await api.post('/orders/createCollectedOrder', {
          orderIds: selected,
          address: this.address,
          extraDrugs: this.extraDrugs,
        });

        if (!data.success) {
          toastr['warning'](data.message || 'Ошибка!');
        } else {
          toastr['success']('Заявка сформированна');
          this.address = null;
          this.deliveryDate = null;
          this.extraDrugs = [];
          await this.search();
        }
        this.loadingBtn = false;
      }
    },
    updateOrderDetails(ordersType, orderId, type, data = null) {
      let orders = [];
      switch (ordersType) {
        case 'confirm':
          orders = this.confirmOrders;
          break;
        case 'moderating':
          orders = this.moderatingOrders;
          break;
        case 'collectedOrders':
          orders = this.collectedOrders;
          break;
      }
      orders.forEach((o, i) => {
        if (o && o.id === orderId) {
          switch (type) {
            case 'status':
              o.status = 5;
              break;
            case 'drugs':
              o.details = data;
              this.sendToModerationOrder(ordersType, orderId, i);
              break;
            case 'price':
              o.price = data;
              break;
            case 'comment':
              o.comment = data;
              break;
            case 'reject':
              delete orders[i];
              orders = [...orders.filter(o => o.id)];
              switch (ordersType) {
                case 'collectedOrders':
                  this.collectedOrders = [...orders];
                  break;
                case 'confirm':
                  this.confirmOrders = [...orders];
                  break;
                case 'moderating':
                  this.moderatingOrders = [...orders];
                  break;
              }
              // this.orders = [...this.orders.filter(o => o.id)];
              break;
          }
        }
      })
    },
    async sendToModerationOrder(ordersType, orderId, index) {
      let {data} = await api.post('/orders/updateNewOrder', {
        editType: 'status',
        status: 0,
        order: {id: orderId},
      });
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка!');
      } else {
        switch (ordersType) {
          case 'confirm':
            this.confirmOrders = [...this.confirmOrders.filter(o => o.id && o.id !== orderId)];
            break;
          case 'moderating':
            this.moderatingOrders = [...this.moderatingOrders.filter(o => o.id && o.id !== orderId)];
            break;
        }
        toastr['success']('Отправлено');
      }
    },
    async search(page = 1) {
      this.confirmOrders = [];
      this.moderatingOrders = [];
      this.collectedOrders = [];
      this.supplyOrders = {};
      this.totalOrders = 0;
      this.searchLoading = true;

      const {data} = await api.index('/orders/getOrdersByClient');

      if (!data.success) {
        this.Toast.fire({
          type: 'warning',
          title: 'Ошибка загрузки заявок'
        })
        this.searchLoading = false;
        return;
      }

      this.rates = data.rates;
      this.confirmOrders = data.confirmOrders;
      this.moderatingOrders = data.moderatingOrders;
      this.supplyOrders = data.supplyOrders;
      this.collectedOrders = data.collectedOrders;
      // const {data: list, ...pagination} = data.records;
      // this.orders = list;
      // this.paginator = pagination;
      // this.currentPage = pagination.current_page;
      // this.totalOrders = pagination.total;

      this.searchLoading = false;
    }
  }
}

</script>

<style scoped>
.table-small-td td {
  padding: 3px;
}
</style>
